'use strict';
angular.module('deleteSharedManuscriptServiceModule', [
		'resourceCenterDeleteManuscriptModule'
	])
    .factory('deleteSharedManuscriptService', ['$q', '$modal', function($q, $modal) {
    	return {
    		deleteManuscript: function(data){
    			var defer = $q.defer();
    			var modalInstance = $modal.open({
    				templateUrl: "./resourceCenter/service/deleteSharedManuscriptService/deleteManuscript_tpl.html",
                    windowClass: 'resource__center__delete__manuscript',
                    backdrop: false,
                    controller: "resourceCenterDeleteManuscriptCtrl",
                    resolve: {
                        data: function() {
                            return {
                                array: data,
                            };
                        }
                    }
    			});
    			modalInstance.result.then(function(result){
    				defer.resolve(result);
    			}, function(){
    				defer.reject();
    			});
    			return defer.promise;
    		}
    	}
    }]);